import get from "lodash/get";
import groupBy from "lodash/groupBy";
import keyBy from "lodash/keyBy";
import filter from "lodash/filter";

import { prismicUids, defaultPrismicDocUid } from "@sendmagic/prismic-nextjs/src/constants/prismic";

export const checkContentPresence = (content) => {
  if (Array.isArray(content)) {
    const [firstElem] = content;
    const { text = "", oembed, url } = firstElem || {};
    return content.length <= 1 ? Boolean(text.trim() || oembed || url) : true;
  }
  return content;
};

export const getOrderConfirmationUid = (
  { allowAnonymousInvite, swagOnly, preCurated = false, isGoodieBagOrder = false },
  userCountryIso = "us",
) => {
  const { orderConfirmation: orderConfirmationUids } = prismicUids;
  const uid = (() => {
    if (isGoodieBagOrder) {
      return orderConfirmationUids.verified.goodie_bag;
    }
    if (allowAnonymousInvite) {
      const countryPrefix = userCountryIso === "us" ? "" : `${userCountryIso}-`;
      if (preCurated) {
        return `${countryPrefix}${orderConfirmationUids.anonymous.pcb}`;
      }
      return `${countryPrefix}${orderConfirmationUids.anonymous.non_pcb}`;
    }
    if (preCurated) {
      return `${userCountryIso}-${orderConfirmationUids.verified.pcb}`;
    }
    return `${userCountryIso}-${orderConfirmationUids.verified.normal}`;
  })();
  const programName = swagOnly ? "swagmagic-" : "";
  return `${programName}${uid}`;
};

export const getLogoDropdownDoc = ({ body = [] } = {}) => ({
  layouts: [body.find(({ slice_type }) => slice_type === "logo_panel")],
});

export const getFormattedMenus = ({ body = [], menus = [] }) => {
  const groupedLayouts = groupBy(body, ({ primary }) => primary?.belongs_to_menu);
  const headerLinks = menus;
  headerLinks.map((menu) => {
    menu.layouts = groupedLayouts[menu?.menu_id];
    const isRelativePositionLayout = ({ slice_type }) =>
      slice_type === "vertical_listing_with_images" || slice_type === "nested_drop_down";
    menu.classIdentifier = menu.layouts?.every(isRelativePositionLayout) ? "position-relative" : "";
  });
  return headerLinks;
};

export const getFormattedMenuCTAs = ({ body = [] }) =>
  body.reduce((formattedMenuCtas, { slice_type, items }) => {
    if (slice_type === "header_ctas") {
      formattedMenuCtas = items.map(({ link, text }) => ({ menu_link: link, menu_name: text }));
    }
    return formattedMenuCtas;
  }, []);

export const parsePrismicProgramConfig = (response, app) => {
  const appPages = filter(response.results, (result) => get(result, "data.app") == app);
  return keyBy(appPages, (prismicPage) => prismicPage.type);
};

export const isPrismicLocalizedDataValid = ({ doc, country = {} }) => {
  const prismicDocUid = doc?.uid;
  const { iso, enabledPricedMenu } = country;
  return (
    prismicDocUid === iso?.toLowerCase() ||
    prismicDocUid === defaultPrismicDocUid ||
    !enabledPricedMenu
  );
};

export const parseTreatDashboardBanner = (apiResponse = {}) => {
  const { primary, items, slice_type: sliceType } = apiResponse?.data?.body[0] || {};
  const {
    logo_image: { url: bannerHeadingImgUrl } = {},
    heading: bannerHeading1 = {},
    heading_2: bannerHeading2 = {},
    cta: bannerCtaUrl1 = {},
    cta2: bannerCtaUrl2 = {},
    bg_color: bannerBgColor = "",
    primary_image: { url: bannerPrimaryImgUrl } = {},
    cta_text: ctaText = "",
  } = primary || {};

  return {
    items,
    sliceType,
    bannerHeadingImgUrl,
    bannerHeading1,
    bannerHeading2,
    bannerCtaUrl1,
    bannerCtaUrl2,
    bannerBgColor,
    bannerPrimaryImgUrl,
    ctaText,
  };
};
